import { render, staticRenderFns } from "./FloatingLocaleSwitcher.vue?vue&type=template&id=911fd732&scoped=true"
import script from "./FloatingLocaleSwitcher.vue?vue&type=script&lang=js"
export * from "./FloatingLocaleSwitcher.vue?vue&type=script&lang=js"
import style0 from "./FloatingLocaleSwitcher.vue?vue&type=style&index=0&id=911fd732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911fd732",
  null
  
)

export default component.exports